export const MarkerTypes = Object.freeze({
    GARRISON: "garrison",
    OUTPOST: "outpost",
    SUPPLIES: "supplies",
    SUPPLY_DROP: "supply_drop",
    TANK_RECON: "tank_recon",
    TANK_LIGHT: "tank_light",
    TANK_MEDIUM: "tank_medium",
    TANK_HEAVY: "tank_heavy"
});

export const MarkerFaction = Object.freeze({
    FRIENDLY: "friendly",
    ENEMY: "enemy"
});
